export const getHMFromShortTimeString = (time) => {
    const [hours, minutes] = time.split(':');
    return [Number(hours), Number(minutes)];
};
export const setHMToDate = (date, hours, minutes) => {
    const newDate = new Date(date);
    newDate.setHours(Number(hours), Number(minutes), 0, 0);
    return newDate;
};
//# sourceMappingURL=utils.js.map